export const stringToSplitNumbersArray = (str?: string | null) =>
  String(str)
    .replace(/\D+/gi, ' ')
    .trim()
    .split(' ')
    .filter((x) => x)
